//import React, { useState } from "react";
import {
    Box,
    Container,
    Typography,
    Paper,
    //Alert,
    Link
} from "@mui/material";
import EventIcon from '@mui/icons-material/Event';
//import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


const meals = [
    { moment: 'Vendredi soir', text: "Salade composée disponible à votre arrivée", included: true },
    { moment: 'Samedi matin', text: "Petit-déjeuner", included: true },
    { moment: 'Samedi midi', text: "Des restaurants sont disponibles autour du domaine ou à Provins", included: false }
];

const StayArriveOnFriday: React.FC = () => {

    return (
        <>


            {/* Section Arrivée le vendredi */}
            <Container maxWidth="md" sx={{ mb: 4 }}>
                <Paper elevation={3} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3 }}>
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <EventIcon sx={{ mr: 2, color: 'primary.main', fontSize: 30 }} />
                            <Typography variant="h5">Arrivée dès le vendredi soir</Typography>
                        </Box>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            Il est possible d'arriver au domaine dès le vendredi soir pour minimiser les trajets le samedi.
                        </Typography>

                        {/* Section Repas */}
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <RestaurantIcon sx={{ mr: 1.5, color: 'secondary.main' }} />
                            <Typography variant="h6">Repas compris</Typography>
                        </Box>
                        <Box sx={{ pl: 1, mb: 2 }}>
                            <Box component="ul" sx={{ pl: 0, mb: 1, listStyle: "none" }}>
                                {meals.map((meal) => (
                                    <li key={meal.moment}>
                                        <Box sx={{ display: "flex", alignItems: "baseline" }}>
                                            {meal.included ? (
                                                <CheckCircleOutlineIcon sx={{
                                                    mr: 1,
                                                    color: "success.main",
                                                    flexShrink: 0,
                                                    position: "relative",
                                                    top: 6,
                                                }} />
                                            ) : (
                                                <CancelOutlinedIcon sx={{
                                                    mr: 1,
                                                    color: "error.main",
                                                    flexShrink: 0,
                                                    position: "relative",
                                                    top: 6,
                                                }} />
                                            )}
                                            <Typography variant="body1">
                                                <strong>{meal.moment}</strong> : {meal.text}
                                            </Typography>
                                        </Box>
                                    </li>
                                ))}
                            </Box>
                        </Box>

                        {/* Section Activités */}
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <LocalActivityIcon sx={{ mr: 1.5, color: 'secondary.main' }} />
                            <Typography variant="h6">Activités</Typography>
                        </Box>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            Le samedi matin est libre, nous vous invitons à visiter les alentours qui regorgent de jolies choses ! (Voir la page <Link href="/visit" color="inherit">Visiter</Link>)
                        </Typography>
                        {/*<Alert severity="info" icon={<InfoOutlinedIcon />} sx={{ mt: 2 }}>
                            N'oubliez pas d'indiquer si vous souhaitez dormir sur place le vendredi et/ou le samedi lors de votre réponse au RSVP.
                        </Alert>*/}
                    </Box>
                </Paper>
            </Container>
        </>
    );
};

export default StayArriveOnFriday;
